import { _get, _post, _delete, _put, _downloadFile } from './fetch'

// 请求示例
export const $get = params => _get('/get/list', params)
export const $post = params => _post('/post/item', params)
export const $delete = params => _delete('/delete/item', params)
export const $put = params => _put('/put/item', params)
export const $downloadFile = params => _downloadFile('/put/item', params)

// 登录
export const login = params => _post('/user/login', params)
export const getCaptcha = params => _get('/kaptcha/captcha', params)
export const portalLogin = config => _get('/user/portalLogin', config) // portal登录

// 礼品卡批次
export const getCardBatchPagination = params => _get('/card/batch/pagination', params) // 礼品卡分页列表查询
export const getCardTypeList = params => _get('/card/type/list', params) // typeList
export const addCardBatch = params => _post('/card/batch', params) // 礼品卡批次添加
export const getFloorShopList = params => _get('/floor/shop/list', params) // 楼层店铺
export const deleteCardBatch = params => _delete('/card/batch', params)
export const handleBindShop = params => _put('/card/batch/bind/store', params)
export const changeCardBatch = params => _put('/card/batch', params)
export const getCardBatchInfo = params => _get('/card/batch/{id}', params) // 获取卡批次详情
export const approvalCardBatch = params => _put('/card/batch/approval/?id={id}', params) // 卡审核
export const getCardsList = params => _get('/card/batch/cards/{id}', params) // 卡列表分页
export const getcardBatchStates = params => _get('/card/batch/states', params) // 状态
export const cardBatchActivation = params => _post('/card/batch/activation', params) // 卡激活

export const handleBindStore = params => _put('/card/type/bind/store', params) //绑定店铺


// 卡管理
export const getCardPagination = params => _get('/card/pagination', params) // 卡分页列表查询
export const activationCard = params => _put('/card/activation?id={id}', params) // 激活
export const terminationCard = params => _put('/card/termination?id={id}', params) // 终止
export const lockingCard = params => _put('/card/locking?id={id}', params) // 锁定
export const invalidCard = params => _put('/card/invalid?id={id}', params) // 作废
export const unlockCard = params => _put('/card/unlock?id={id}', params) // 解锁
export const getCardStates = params => _get('/card/states', params) // 状态
export const extensionCard = params => _put('/card/extension', params) // 延期
export const rechargeCard = params => _put('/card/recharge', params) // 充值
export const exportCard = params => _get('/card/export', params) // 导出
export const getSolaCard = params => _get('/card/one', params) // 根据卡号或会员号查询
export const getCardInfo = params => _get('/card/detail/{id}', params) // 详情
export const getConsumeList = params => _get('/card/consume/record/pagination', params) // 消费分页列表
export const getDynamiCardList = params => _get('/recharge/record/pagination', params) // 动态卡充值确认表格查询
export const dynamiCardPass = params => _get('/recharge/record/complate', params) // 动态卡充值确认 通过&驳回
export const batchJudgeTopUpMoney = params => _put('/card/recharge/batch', params) // 批量卡充值确认
export const getCardManageListApi = params => _get('/card/manage/list', params) // 卡管理列表查询

// 任务
export const getTaskPagination = params => _get('/task/pagination', params) // 任务分页列表
export const downloadTaskFile = params => _downloadFile('/task/file/{id}', params) // 文件下载

// 设置
// 卡类型
export const getCardTypePageList = params => _get('/card/type/page', params) // 卡类型设置分页
export const getChangeCardType = params => _put('/card/type', params) // 修改卡类型
export const addCardType = params => _post('/card/type', params) // 添加卡类型
export const getCardTypeInfo = params => _get('/card/type/{id}', params) // 通过主键查询单条数据
export const deleteCardType = params => _delete('/card/type/{id}', params) // 通过主键删除数据
export const detailCreditApi = params => _get('/card/type/credit/record/{id}', params) // 通过卡类型主键查询授信记录
export const adjustCardCreditApi = params => _put(`/card/type/credit/adjust/${params.id}?amount=${params.amount}`) // 调整卡类型授信
export const enableCardCreditApi = params => _put(`/card/type/${params.cardId}/${params.enable}`) // 更新启用禁用授信状态
// 手续费设置
export const getRatePage = params => _get('/rate/page', params) // 手续费设置分页
export const addRate = params => _post('/rate', params) // 添加手续费设置
export const getrateInfo = params => _get('/rate/{id}', params) // 通过主键查询单条手续费
export const changeRate = params => _put('/rate', params) // 通过主键查询单条手续费
export const deleteRate = params => _delete('/rate/{id}', params) // 通过主键查询单条手续费

// 角色管理
export const getRolePage = params => _get('/role/page', params) // 角色分页
export const addRole = params => _post('/role', params) // 添加角色
export const changeRole = params => _put('/role', params) // 修改数据
export const getRoleInfo = params => _get('/role/{id}', params) // 通过主键查询单条数据
export const deleteRole = params => _delete('/role/{id}', params) // 通过主键删除数据
export const getRoleList = params => _get('/role/list', params) // 所有角色list ，/下拉

// 用户管理
export const addUser = params => _post('/user', params) // 添加用户
export const getUserPage = params => _get('/user/page', params) // 用户分页
export const getUserInfo = params => _get('/user/{id}', params) // 通过主键查询单条数据
export const changeUser = params => _put('/user', params) // 修改数据
export const deleteUser = params => _delete('/user/{id}', params) // 通过主键删除数据
export const updatePassword = params => _post('/user/update/password', params) // 用户修改密码
export const updateDataAuthApi = params => _post('/user/update/acl', params) // 数据权限

//卡转赠记录 
export const transferRecordPageApi = params => _post('/card/transfer/record/page', params) // 查询

// 核销汇总
export const getsummaryList = params => _get('/report/consume/summary/select', params) // 查询
export const defaultSummaryList = params => _get('/report/consume/summary/export', params) // 导出
export const summarySum = params => _get('/report/consume/summary/sum', params) // 合计
// 核销明细
export const getDetailList = params => _get('/report/consume/detail/select', params) // 查询
export const defaultDetailList = params => _get('/report/consume/detail/export', params) // 导出
export const DetailSum = params => _get('/report/consume/detail/sum', params) // 合计
// 手续费汇总
export const getRateSummaryList = params => _get('/report/rate/summary/select', params) // 查询
export const defaultRateSummaryList = params => _get('/report/rate/summary/export', params) // 导出
export const rateSummarySum = params => _get('/report/rate/summary/sum', params) // 合计

// 手续费明细
export const getRateDetailList = params => _get('/report/rate/detail/select', params) // 查询
export const defaultRateDetailList = params => _get('/report/rate/detail/export', params) // 导出
export const rateDetailSum = params => _get('/report/rate/detail/sum', params) // 合计

// 售卡统计
export const getSellList = params => _get('/report/sell/select', params) // 查询
export const defaultsellList = params => _get('/report/sell/export', params) // 导出

// 权限
export const getMenuList = params => _get('/menu/list', params) // 查询多条数据

// 储值卡入库
export const getStoreCardListApi = params => _get('/card/inbound/list', params) // 查询
export const createInboundSnApi = params => _get('/card/inbound/gen/sn', params) // 生成入库批次号
export const inboundCardApi = params => _post('/card/inbound', params) // 卡入库

// 储值卡入库审核
export const getStoreCardExamListApi = params => _get('/card/inbound/confirm/list', params) // 查询
export const examStoreCardApi = params => _put(`/card/inbound?ids=${params.ids}`, params) // 审核

// 储值卡售卡
export const getStoreCardSaleListApi = params => _get('/sell/pagination', params) // 查询
export const exportSaleCardApi = params => _get('/sell/export', params) // 导出
export const detailSaleCardApi = params => _get('/sell/detail/{id}', params) // 详情
export const deleteSaleCardApi = params => _delete(`/sell/card/${params.cardId}`) // 弹窗删除卡
export const sendSaleCardApi = params => _put(`/sell/release/${params.orderId}`, { isSpec: true }) // 发卡
export const awaitSendCardApi = params => _put(`/sell/to/sell/${params.orderId}`, { isSpec: true }) // 待发卡
export const searchSellDraftApi = params => _get('/sell', params) // 查询售卡草稿
export const updateSellDraftApi = params => _post('/sell/update/info', params) // 更新售卡草稿
export const scanSellCardApi = params => _post('/sell', params) // 扫描售卡
export const cancelSellCardApi = params => _put(`/sell/cancel/${params.orderId}`, { isSpec: true }) // 取消售卡
export const updateCardAmountApi = params => _put(`/sell/${params.cardId}?amount=${params.amount}`) // 更新卡面值
export const batchUpdateCardAmountApi = params => _put(`/sell/batch/${params.orderId}?amount=${params.amount}`) // 批量更新卡面值
export const searchOrderCardListApi = params => _get('/sell/card/pagination', params) // 订单关联卡列表查询
export const searchOrderCardAllListApi = params => _get('/sell/card/pagination/all', params) // 订单关联卡列表查询
export const deleteOrderCardApi = params => _delete(`/sell/order/${params.orderId}`) // 列表中删除订单
// 售卖调整价设置
export const getCardPriceListApi = params => _get('/card/cardTypeAmountRecord/page', params) // 查询
export const setSaleCardPriceApi = params => _post('/card/cardTypeAmountRecord/insert', params) // 保存设置
export const cardTypeAmountRecordInvalidApi = id => _post(`/card/cardTypeAmountRecord/invalid/${id}`) // 设置调整价失效

// 充值优惠规则
export const discountRuleListApi = params => _get('/recharge/discount/rule/pagination', params) // 分页列表查询
export const discountRuleAddApi = params => _post('/recharge/discount/rule', params) // 新增
export const discountRuleEditApi = params => _put('/recharge/discount/rule', params) // 编辑
export const discountRuleStateApi = params => _put(`/recharge/discount/rule/state?ids=${params.ids}&state=${params.state}`) // 状态更新
export const discountRuleDeleteApi = id => _delete(`/recharge/discount/rule/${id}`) // 删除

//风控监测视图
export const riskBusiness = params => _get('/report/risk/business', params) // 进度条数据
export const errorBindShort = params => _get('/report/risk/error/bind/short', params) // 异常数据简要
export const errorBindList = params => _get('/report/risk/error/bind/list', params) // 异常数据列表
export const errorBindListExport = params => _get('/report/risk/error/bind/list/export', params) // 异常数据列表导出

// 绑卡记录
export const recordList = params => _get('/report/risk/bind/record/list', params) // 绑卡记录列表
export const recordListExport = params => _get('/report/risk/bind/record/list/export', params) // 绑卡记录导出

export const rechargeistExport = params => _get('/recharge/record/export', params) // 充值记录导出
export const activationLot = params => _post('/card/activation/lot', params) // 批量激活
export const activationAll = params => _put('/card/activation/all', params) // 激活全部

// 卡规则设置
export const cardRuleListApi = () => _get('/card/rule/list')
export const cardRuleUpdateApi = params => _post('/card/rule/update', params)


export const accountLimitInfoApi = params => _get('/card/account/limit/info', params)
export const accountLimitLockApi = params => _post('/card/account/limit/lock', params)
export const accountLimitUpdateApi = params => _post('/card/account/limit/update', params)

// 退卡接口
export const refundApplyApi = params => _post('/refund/apply', params) //申请退卡
export const refundAuditApi = params => _post('/refund/audit', params)//退卡审核
export const refundDetailListApi = params => _get('/refund/detail/list', params) //退卡明细列表
export const refundListApi = params => _get('/refund/list', params) //退卡审核申请列表

export const sellDetailApi = orderSn => _get(`/sell/detail/sn/${orderSn}`) //详情(根据订单编号查询)
export const sellCardListApi = params => _get(`/sell/card/pagination/refund`, params) //订单关联卡列表查询

export const cardTransferExportApi = params => _get('/card/transfer/record/export', params) // 卡转增记录导出
export const refundDetailExportApi = params => _get('/refund/detail/export', params) // 退卡明细导出


